import { useSelector } from 'react-redux'
import {
  CommodityFilterModel,
  CustomFilterModel,
  DataTableFilter,
  DateFilterModel,
  PageStateStoreModel,
  RootStoreModel
} from '../redux'

const usePageState = () => {
  const currentPage: string = useSelector((state: RootStoreModel) => {
    return state.router && state.router.location && state.router.location.pathname
  })

  const dataTableFilter: DataTableFilter | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.dataTableFilter
  })

  const dataTableSearch: string | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.dataTableSearch
  })

  const dataTableRowsPerPage: number | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.dataTableRowsPerPage
  })

  const dateFilter: DateFilterModel | undefined = useSelector((state: RootStoreModel) => {
    const currentPageState = state.pagesState.find(
      (pageState: PageStateStoreModel) => pageState.page === currentPage
    )
    if (!currentPageState) return

    const { dateFilter } = currentPageState

    return dateFilter

    // if not date filter is applied, return dates from the applied custom filter.
    // return (
    //   dateFilter || {
    //     initDate: customFilter && customFilter.startDate,
    //     endDate: customFilter && customFilter.endDate,
    //     activeDateFilter: DateFilters.CUSTOM
    //   }
    // );
  })

  const customFilter: CustomFilterModel | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.customFilter
  })

  const activeTab: number | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.activeTab
  })

  const activeTabPower: number | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.activeTabPower
  })

  const commodityFilter: CommodityFilterModel | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.commodityFilter
  })

  const showOnlyActivesFilter: boolean | undefined = useSelector((state: RootStoreModel) => {
    return state.pagesState.find((pageState: PageStateStoreModel) => pageState.page === currentPage)
      ?.showOnlyActivesFilter
  })

  return {
    dataTableFilter,
    dataTableSearch,
    dataTableRowsPerPage,
    dateFilter,
    customFilter,
    activeTab,
    activeTabPower,
    commodityFilter,
    showOnlyActivesFilter
  }
}

export { usePageState }
